import gql from 'graphql-tag';
export default gql`
  mutation DeleteQuestionById($input: DeleteQuestionByIdInput!) {
    deleteQuestionById(input: $input) {
      deletedQuestionId
    }
  }
`;
